import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileChart: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFileChart"><Path fillRule="evenodd" clipRule="evenodd" d="M4.75 2H12V10H20V21.25C20 21.6642 19.6642 22 19.25 22H4.75C4.33579 22 4 21.6642 4 21.25V2.75C4 2.33579 4.33579 2 4.75 2ZM9.25 16H7.75V19H9.25V16ZM12.75 13V19H11.25V13H12.75ZM16.25 15H14.75V19H16.25V15Z" fill="currentColor"/><Path d="M13.5 2.43934L19.5607 8.5H13.5V2.43934Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileChart;
